var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container page-router-component"},[_c('router-view',{staticStyle:{"width":"100%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }